import { render, staticRenderFns } from "./RegistrationSymbolMasterPage.vue?vue&type=template&id=45bc886c&scoped=true&"
import script from "./RegistrationSymbolMasterPage.vue?vue&type=script&lang=js&"
export * from "./RegistrationSymbolMasterPage.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSymbolMasterPage.vue?vue&type=style&index=0&id=45bc886c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bc886c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45bc886c')) {
      api.createRecord('45bc886c', component.options)
    } else {
      api.reload('45bc886c', component.options)
    }
    module.hot.accept("./RegistrationSymbolMasterPage.vue?vue&type=template&id=45bc886c&scoped=true&", function () {
      api.rerender('45bc886c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/master/registrationSymbolMaster/RegistrationSymbolMasterPage.vue"
export default component.exports